export default "__VITE_ASSET__Cu$gkrJ4__"